import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/Settings.css';

const Settings = () => {
  const [settings, setSettings] = useState({
    laborCostPerHour: 150
  });
  const [priceLists, setPriceLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [settingsRes, priceListsRes] = await Promise.all([
        api.get('/settings'),
        api.get('/price-lists')
      ]);
      setSettings(settingsRes.data);
      setPriceLists(priceListsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveLaborCost = async () => {
    setSaving(true);
    try {
      await api.put('/settings/laborCostPerHour', { value: settings.laborCostPerHour });
      alert('עלות שעת עבודה נשמרה בהצלחה');
    } catch (error) {
      alert('שגיאה בשמירה');
    } finally {
      setSaving(false);
    }
  };

  const handleInitSettings = async () => {
    try {
      await api.post('/settings/init');
      fetchData();
      alert('הגדרות אותחלו בהצלחה');
    } catch (error) {
      alert('שגיאה באתחול');
    }
  };

  const handleUpdatePriceList = async (id, marginPercent) => {
    try {
      await api.put(`/price-lists/${id}`, { marginPercent });
      fetchData();
    } catch (error) {
      alert('שגיאה בעדכון');
    }
  };

  if (loading) {
    return <div className="loading">טוען...</div>;
  }

  return (
    <div className="settings">
      <div className="page-header">
        <h1>הגדרות</h1>
      </div>

      {/* Labor Cost Section */}
      <div className="settings-section">
        <h2>עלות עבודה</h2>
        <div className="settings-card">
          <div className="setting-row">
            <label>עלות שעת עבודה (₪)</label>
            <div className="setting-input-group">
              <input
                type="number"
                min="0"
                step="1"
                value={settings.laborCostPerHour || 150}
                onChange={(e) => setSettings({ ...settings, laborCostPerHour: parseFloat(e.target.value) })}
              />
              <button className="btn-primary" onClick={handleSaveLaborCost} disabled={saving}>
                {saving ? 'שומר...' : 'שמור'}
              </button>
            </div>
          </div>
          <p className="setting-hint">
            עלות זו תתווסף לחישוב העלות הכוללת של כל מוצר לפי שעות העבודה שהוגדרו לו
          </p>
        </div>
      </div>

      {/* Price Lists Section */}
      <div className="settings-section">
        <h2>מחירונים</h2>
        <div className="settings-card">
          <div className="price-lists-grid">
            {priceLists.map(priceList => (
              <div key={priceList._id} className="price-list-item">
                <span className="price-list-name">{priceList.name}</span>
                <div className="price-list-input">
                  <input
                    type="number"
                    min="0"
                    value={priceList.marginPercent}
                    onChange={(e) => handleUpdatePriceList(priceList._id, parseFloat(e.target.value))}
                  />
                  <span>%</span>
                </div>
              </div>
            ))}
          </div>
          {priceLists.length === 0 && (
            <div className="no-data">
              <p>לא נמצאו מחירונים</p>
              <button className="btn-primary" onClick={handleInitSettings}>
                אתחל הגדרות ומחירונים
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Init Button */}
      <div className="settings-section">
        <button className="btn-init" onClick={handleInitSettings}>
          אתחל הגדרות ברירת מחדל
        </button>
      </div>
    </div>
  );
};

export default Settings;